import _orderBy from 'lodash/orderBy';
import _ceil from 'lodash/ceil';
import _uniq from 'lodash/uniq';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import moment from 'moment';
import reportDao from '../../../../dao/reportDao';
import skuDao from '../../../../dao/skuDao';
import {exampleData} from './components/exampleData';
import {eyewearExampleData} from './components/eyewearExampleData';
import _isUndefined from 'lodash/isUndefined';
import smbUtils from '../../../../utils/smbUtils';
import eyewearDao from '../../../../dao/eyewearDao';
import accountDao from '../../../../dao/accountDao';

const INIT = 'pages/webmodule/reports/skupreferences/INIT';
const LIST = 'pages/webmodule/reports/skupreferences/LIST';
const CHANGE_DATE_RANGE =
  'pages/webmodule/reports/skupreferences/CHANGE_DATE_RANGE';
const SORT = 'pages/webmodule/reports/skupreferences/SORT';
const PAGE = 'pages/webmodule/reports/skupreferences/PAGE';
const SIZE = 'pages/webmodule/reports/skupreferences/SIZE';
const FILTER_DATA = 'pages/webmodule/reports/skupreferences/FILTER_DATA';
const FILTER_DATA_SUCCESS =
  'pages/webmodule/reports/skupreferences/FILTER_DATA_SUCCESS';
const SEARCH = 'pages/webmodule/reports/skupreferences/SEARCH';
const FETCHING = 'pages/webmodule/reports/skupreferences/FETCHING';
const FETCH_LIST_SUCCESS =
  'pages/webmodule/reports/skupreferences/FETCH_LIST_SUCCESS';
const LOAD_EXAMPLE = 'pages/webmodule/reports/skupreferences/LOAD_EXAMPLE';
const SET_REPORT_VIEWED =
  'pages/webmodule/reports/skupreferences/SET_REPORT_VIEWED';

const initialState = {
  allSkuPreferences: [],
  skuPreferences: [],
  loaded: false,
  grid: {
    sort: 'tryout',
    asc: false,
    pageIndex: 1,
    pageSize: 10,
    pages: 1,
    totalSize: 0,
  },
  since: moment().subtract(1, 'month'),
  until: moment(),
  isExampleData: false,
  reportViewed: false,
  searchParams: {},
  functionType: 'MAKEUP',
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {...initialState};
    case LIST:
      return {
        ...state,
        allSkuPreferences: [],
        skuPreferences: [],
        since: state.since,
        until: state.until,
        isExampleData: false,
      };
    case CHANGE_DATE_RANGE:
      return {
        ...state,
        since: action.since,
        until: action.until,
      };
    case SORT:
      return {
        ...state,
        grid: {
          ...state.grid,
          sort: action.sort,
          asc: state.grid.sort === action.sort ? !state.grid.asc : false,
        },
      };
    case PAGE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageIndex: action.pageIndex,
        },
      };
    case SIZE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageSize: action.pageSize,
          pages: _ceil(state.grid.totalSize / action.pageSize),
          pageIndex: 1,
        },
      };
    case SEARCH:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.params,
        },
        grid: {
          ...state.grid,
          pageIndex: 1,
        },
      };
    case FILTER_DATA:
      return {
        ...state,
      };
    case FILTER_DATA_SUCCESS:
      return {
        ...state,
        skuPreferences: action.json,
        grid: {
          ...state.grid,
          totalSize: action.json.length,
          pages: _ceil(action.json.length / state.grid.pageSize),
        },
      };
    case FETCHING:
      return {
        ...state,
        loaded: false,
      };
    case FETCH_LIST_SUCCESS:
      return {
        ...state,
        loaded: true,
        allSkuPreferences: action.skuPreferences,
        skuPreferences: action.skuPreferences,
        since: state.since,
        until: state.until,
      };
    case LOAD_EXAMPLE:
      const newState3 = {...state};
      const data =
        action.accountSummary.customer.functionType === 'EYEWEAR'
          ? eyewearExampleData()
          : exampleData();
      const skupreferences = data.response.skupreferences;
      newState3.allSkuPreferences = skupreferences;
      newState3.skuPreferences = skupreferences;
      newState3.since = moment(data.request.begin);
      newState3.until = moment(data.request.end);
      newState3.isExampleData = true;
      return newState3;
    case SET_REPORT_VIEWED:
      return {
        ...state,
        reportViewed: action.reportViewed,
      };
    default:
      return state;
  }
}

export function init() {
  return dispatch => {
    dispatch({type: INIT});
    return dispatch(fetchListAsync());
  };
}

export function list() {
  return dispatch => {
    dispatch({type: LIST});
    return dispatch(fetchListAsync());
  };
}

export function changeDateRange(since, until) {
  return {
    type: CHANGE_DATE_RANGE,
    since,
    until,
  };
}

function fetching() {
  return {
    type: FETCHING,
  };
}

function fetchListAsync() {
  return (dispatch, getState) => {
    const functionType = getState().components.auth.accountSummary.customer
      .functionType;
    dispatch(fetching());

    const params = {
      begin: getState().pages.webmodule.reports.skupreferences.since.format(
        'YYYY-MM-DD'
      ),
      end: getState().pages.webmodule.reports.skupreferences.until.format(
        'YYYY-MM-DD'
      ),
    };
    reportDao.listSkuPreference(params).then(json => {
      let skuIds = [];
      json.forEach(c => {
        if (c && c.sku) {
          skuIds.push(c.sku.id);
        }
      });
      dispatch(fetchSkuList(_uniq(skuIds), json, functionType));
      // dispatch(fetchListSuccess(json));
    });
  };
}

function fetchSkuList(skuIds, skuPreferences, functionType) {
  return async dispatch => {
    dispatch(fetching());

    let skuList = [];
    let lensList = [];
    const pageSize = 20;
    while (skuIds.length > 0) {
      const querySkuIds = skuIds.splice(0, pageSize);
      const params = {skuIds: querySkuIds};
      const result = await skuDao.querySkus(params);
      skuList = skuList.concat(result);
    }
    await accountDao.queryEngagement().then(r => {
      dispatch(setReportViewed(r.reportViewed));
    });
    if (functionType === 'EYEWEAR') {
      await eyewearDao.listAllLens().then(lens => {
        if (lens.results) {
          lensList = lens.results;
        }
      });
    }
    dispatch(fetchListSuccess(skuList, skuPreferences, functionType, lensList));
    dispatch(loadExampleIfNeeded());
    dispatch(filterData());
  };
}

function fetchListSuccess(skuList, skuPreferences, functionType, lensList) {
  let results = [];

  if (!skuPreferences || !skuPreferences.length) {
    return {
      type: FETCH_LIST_SUCCESS,
      totalSize: 0,
      skuPreferences: [],
    };
  }

  if (functionType === 'EYEWEAR') {
    results = skuPreferences.map(r => {
      return {
        category: _get(r, 'product.parent.i18n.enu.productName', ''),
        skuName: _get(r, 'sku.i18n.enu.skuName', ''),
        lensTint: _get(
          lensList.find(l => l.lensNo === _get(r, 'lensNo', '')),
          'i18n.enu.lensName',
          ''
        ),
        size: _get(r, 'frameSizeType', ''),
        tryout: r.tryCount,
        save: r.saveCount,
        saveCTR: r.saveCTR,
      };
    });
  } else {
    results = skuPreferences.map(r => {
      const skuData =
        skuList && r.sku ? _find(skuList, s => s.id === r.sku.id) : {};
      let colors = _get(skuData, 'color', []);
      if (!_isArray(colors)) {
        colors = colors ? [colors] : [];
      }
      return {
        category: _get(skuData, 'skuType', ''),
        skuName: _get(skuData, 'skuName', ''),
        color: colors,
        seriesImgUrl: _get(skuData, 'imageUrl', ''),
        tryout: r.tryCount,
        save: r.saveCount,
        saveCTR: r.saveCTR,
      };
    });
  }

  return {
    type: FETCH_LIST_SUCCESS,
    totalSize: results.length,
    skuPreferences: results,
  };
}

function loadExample(accountSummary) {
  return {
    type: LOAD_EXAMPLE,
    accountSummary,
  };
}

function loadExampleIfNeeded() {
  return (dispatch, getState) => {
    const accountSummary = getState().components.auth.accountSummary;
    const skupreferences = getState().pages.webmodule.reports.skupreferences;
    const isReportViewed = getState().pages.webmodule.reports.skupreferences
      .reportViewed;
    const shouldLoadExample =
      !isReportViewed &&
      (skupreferences.loaded &&
        (_isUndefined(skupreferences.skuPreferences) ||
          !skupreferences.skuPreferences.length));
    if (shouldLoadExample) {
      dispatch(loadExample(accountSummary));
    }
  };
}

function filterData() {
  return (dispatch, getState) => {
    const grid = getState().pages.webmodule.reports.skupreferences.grid;
    let skus = getState().pages.webmodule.reports.skupreferences
      .allSkuPreferences;
    const filterParams = smbUtils.omit(
      getState().pages.webmodule.reports.skupreferences.searchParams
    );
    if (filterParams.skuName) {
      skus = skus.filter(s =>
        s.skuName
          ? s.skuName.search(new RegExp(filterParams.skuName, 'i')) !== -1
          : s.i18n &&
            s.i18n.enu &&
            s.i18n.enu.skuName.search(new RegExp(filterParams.skuName, 'i')) !==
              -1
      );
    }
    if (filterParams.category) {
      skus = skus.filter(s => s.category === filterParams.category);
    }
    if (filterParams.lensTint) {
      skus = skus.filter(
        s =>
          s.lensTint &&
          s.lensTint.search(new RegExp(filterParams.lensTint, 'i')) !== -1
      );
    }
    if (filterParams.size) {
      skus = skus.filter(s => s.size === filterParams.size);
    }
    skus = _orderBy(skus, grid.sort, grid.asc ? 'asc' : 'desc');
    return dispatch(filterDataSuccess(skus));
  };
}

function filterDataSuccess(json) {
  return {
    type: FILTER_DATA_SUCCESS,
    json,
  };
}

export function search(params) {
  return dispatch => {
    dispatch({
      type: SEARCH,
      params,
    });
    return dispatch(filterData());
  };
}

export function sort(sort) {
  return dispatch => {
    dispatch({
      type: SORT,
      sort,
    });
    return dispatch(filterData());
  };
}

export function page(params) {
  return {
    type: PAGE,
    pageIndex: params.selected + 1,
  };
}

export function size(pageSize) {
  return {
    type: SIZE,
    pageSize,
  };
}

export function setReportViewed(reportViewed) {
  return {
    type: SET_REPORT_VIEWED,
    reportViewed,
  };
}
